<!--
 * @Description:
 * @Date: 2021-07-30 11:18:25
-->
<template>
  <div>
    <div class="app-detail-item-title">
      <span>开票信息</span>
      <el-button
        v-if="from !== '发票上传'"
        icon="el-icon-plus"
        size="small"
        @click="addInfo"
        :disabled="
          gongyeList.length > 0 && gongyeList[gongyeList.length - 1].isEdit
        "
      >
        新增开票信息
      </el-button>
      <span v-else></span>
    </div>

    <table-render
      hidePagination
      ref="tableRender"
      :config="config"
      :propData="{ query: {} }"
    />

    <div class="app-detail-item-title">
      <span>发票类目</span>
      <el-button
        icon="el-icon-plus"
        size="small"
        :disabled="items.length > 0 && items[items.length - 1].isEdit"
        @click="items.push({ itemName: '', isEdit: true, isDelete: 0 })"
      >
        添加类目
      </el-button>
    </div>
    <div style="display:flex;margin-top:25px;flex-wrap:wrap;">
      <el-input
        :maxlength="100"
        v-for="(item, index) in items"
        :key="item.id"
        v-model="item.itemName"
        :disabled="!item.isEdit"
        style="width:200px;margin:0 15px 15px 0;"
      >
        <div slot="append" style="font-size: 22px;">
          <template v-if="item.isEdit">
            <i class="el-icon-circle-check" @click="saveItem(item)"></i>
            <i class="el-icon-delete" @click="delItem(item, index)"></i>
          </template>
          <i
            class="el-icon-edit-outline"
            @click="item.isEdit = true"
            v-else
          ></i>
        </div>
      </el-input>
    </div>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import { invoiceNew } from '@/api/ajax';
export default {
  name: 'invoiceInfoList',
  props: ['from'],
  components: { tableRender },
  data() {
    return {
      gongyeList: [],
      items: []
    };
  },
  computed: {
    config() {
      const render = maxlength => {
        return (h, ctx, r, info) => {
          return (
            <div class="cell el-tooltip" style="padding:0;">
              {r['isEdit'] ? (
                <el-input v-model={r[info['property']]} maxlength={maxlength} />
              ) : (
                <span>{r[info['property']]}</span>
              )}
            </div>
          );
        };
      };
      const fields = [
        {
          width: '60px',
          type: 'index',
          label: '序号'
        },
        {
          label: '发票抬头',
          prop: 'gongyeEnterpriseName'
        },
        {
          label: '企业税号',
          prop: 'gongyeEnterpriseIdentifierNo',
          render: render(30)
        },
        {
          label: '联系电话',
          prop: 'enterprisePhone',
          render: render(99)
        },
        {
          label: '开户银行',
          prop: 'openBank',
          render: render(30)
        },
        {
          label: '银行账号',
          prop: 'bankNo',
          render: render(30)
        },
        {
          label: '企业地址',
          prop: 'gongyeEnterpriseAddress',
          render: render(30)
        },
        {
          label: '收件人',
          prop: 'receiveName',
          render: render(30)
        },
        {
          label: '联系方式',
          prop: 'receivePhone',
          render: render(99)
        },
        {
          label: '邮寄地址',
          prop: 'mailAddress',
          render: render(30)
        },
        {
          label: '操作',
          render: (h, ctx, r) => {
            return (
              <div style="font-size: 22px;">
                {r.isEdit ? (
                  <div>
                    <i
                      class="el-icon-circle-check"
                      style="margin-right: 10px;"
                      onClick={() => {
                        const checkPhoneKeys = [
                          {
                            keyName: 'enterprisePhone',
                            message: '请输入正确的企业联系电话'
                          }
                        ];
                        const checkEmptyKeys = [
                          {
                            keyName: 'gongyeEnterpriseName',
                            message: '请输入发票抬头'
                          },
                          {
                            keyName: 'gongyeEnterpriseIdentifierNo',
                            message: '请输入企业税号'
                          },
                          {
                            keyName: 'openBank',
                            message: '请输入开户银行'
                          },
                          {
                            keyName: 'bankNo',
                            message: '请输入银行账号'
                          },
                          {
                            keyName: 'gongyeEnterpriseAddress',
                            message: '请输入企业地址'
                          }
                        ];
                        const errObj =
                          checkPhoneKeys.find(
                            ({ keyName }) => !/^\d+-?\d+\b$/.test(r[keyName])
                          ) ||
                          checkEmptyKeys.find(({ keyName }) => !r[keyName]);
                        if (errObj) {
                          this.$message.error(errObj.message);
                          return;
                        }
                        invoiceNew.editCsoInfo(r).then(() => {
                          if (!r.id) {
                            ctx.parent.handleSearch();
                          }
                          this.$message.success('保存成功');
                          r.isEdit = false;
                        });
                      }}
                    ></i>
                  </div>
                ) : (
                  <i
                    class="el-icon-edit-outline"
                    onClick={() => {
                      r.isEdit = true;
                    }}
                  ></i>
                )}
              </div>
            );
          }
        }
      ];
      return [
        {
          name: '开票信息',
          childMenu: [
            {
              name: '开票信息',
              search: [],
              list: () => {
                return new Promise(resolve => {
                  invoiceNew
                    .getGongyeEnterprise()
                    .then(({ data: { data } }) => {
                      this.gongyeList = data.map(item => ({
                        ...item,
                        isEdit: false
                      }));
                      resolve({
                        data: {
                          data: this.gongyeList
                        }
                      });
                    });
                });
              },
              requestNow: true,
              fields
            }
          ]
        }
      ];
    }
  },
  methods: {
    addInfo() {
      this.$refs['tableRender'].$refs['table'].tableData.push({
        gongyeEnterpriseName: '',
        gongyeEnterpriseIdentifierNo: '',
        gongyeEnterpriseAddress: '',
        enterprisePhone: '',
        openBank: '',
        bankNo: '',
        receiveName: '',
        receivePhone: '',
        mailAddress: '',
        isEdit: true
      });
    },
    saveItem(item) {
      invoiceNew.editCsoItem(item).then(() => {
        this.$message.success('保存成功');
        item.isEdit = false;
      });
    },
    delItem(item, index) {
      const ok = () => {
        this.$message.success('删除成功');
        this.items.splice(index, 1);
      };
      if (item.id) {
        invoiceNew
          .deleteCsoItem({
            id: item.id
          })
          .then(ok);
      } else {
        ok();
      }
    }
  },
  created() {
    invoiceNew.getCsoInvoiceCate().then(({ data: { data } }) => {
      this.items = data.map(item => ({
        ...item,
        isEdit: false
      }));
    });
  }
};
</script>
<style lang="scss" scoped>
.app-detail-item-title {
  display: flex;
  align-items: center;
  & > span {
    margin-right: 10px;
  }
}
</style>
